import { render, staticRenderFns } from "./form-forgot-password.vue?vue&type=template&id=df2ff7a0"
import script from "./form-forgot-password.vue?vue&type=script&lang=js"
export * from "./form-forgot-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports